import {
  CustomerAddressError,
  makeCustomerRequest
} from '@api/graphqlShopify/makeCustomerRequest'
import { AddressData } from '../config'
import { customerAddressDeleteMutation } from '@api/graphqlShopify/mutations'
import { parse } from '@helpers/shopify'
import { getErrorMessage } from '@api/graphqlShopify'
import trackError from '@helpers/trackError'

export async function addressDelete(
  addressId: Partial<AddressData['id']>,
  token: string
) {
  try {
    if (!addressId) {
      throw Error('No address id')
    }

    const { data } = await makeCustomerRequest<{
      customerAddressDelete: {
        userErrors: CustomerAddressError[]
        deletedAddressId: AddressData['id']
      }
      addressId: string
    }>(
      customerAddressDeleteMutation,
      {
        addressId
      },
      token
    )

    const { deletedAddressId, userErrors } = parse(
      data.customerAddressDelete
    ) as {
      deletedAddressId: AddressData['id']
      userErrors: CustomerAddressError[]
    }

    if (userErrors?.length) {
      throw userErrors
    }

    return deletedAddressId
  } catch (e) {
    const error = e as Error
    const errorMessage = getErrorMessage(error)
    trackError(new Error(`addressDelete failed - ${errorMessage}`), {
      addressId: addressId,
      error,
      section: 'Account Page'
    })
    throw error
  }
}
